// Kanban plugin mutation types
// These are plugin-specific and NOT in core mutation-types.js
export default {
    SET_KANBAN_ENABLED: 'SET_KANBAN_ENABLED',
    SET_FUNNELS: 'SET_FUNNELS',
    SET_SELECTED_FUNNEL: 'SET_SELECTED_FUNNEL',
    SET_FUNNEL_UI_FLAG: 'SET_FUNNEL_UI_FLAG',
};
